exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\n  vertical-align: middle !important;\n  display: inline !important;\n}\ninput[type=checkbox] {\n  margin-right: 5px;\n  vertical-align: middle !important;\n  display: inline !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/company/new-company/new-company.component.css
// module id = ../../../../../src/app/_components/company/new-company/new-company.component.css
// module chunks = main